import { Box } from '@chakra-ui/layout';

export function Error404Page(): JSX.Element {
  return <Box>404</Box>;
}
